export const isProduction = import.meta.env.REACT_APP_ENV === 'prod';
export const isStaging = import.meta.env.REACT_APP_ENV === 'stage';
export const isUat = import.meta.env.REACT_APP_ENV === 'uat';
export const isDev = import.meta.env.REACT_APP_ENV === 'dev';
